import { Col, Container, Row } from 'react-bootstrap';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from '@/src/components/common/ui/buttons/Button.jsx';
import DrawSVGPlugin from 'gsap/dist/DrawSVGPlugin';
import Hamburger from '@/src/components/common/ui/buttons/Hamburger.jsx';
import Link from 'next/link';
import ReactHtmlParser from 'react-html-parser';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { StyledComponent } from '@/src/components/layout/menu/men.style.js';
import gsap from 'gsap';
import reactHtmlParser from 'react-html-parser';
import useContainerOffset from '@/src/hooks/useContainerOffset.jsx';
import { usePathname } from 'next/navigation';
import { useShowSetting } from '@/src/components//context/ShowSettingProvider.jsx';
import { useRouter } from 'next/navigation';
import { smoothScrollTo } from '@/src/hooks/smoothScroll.js';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, ScrollToPlugin);

const MenuComponent = () => {
	const getData = useShowSetting();
	const offset = useContainerOffset('.container');
	const getMenuData = getData?.getMenu?.top_menu;
	const getMenuDataHamburger = getData?.getMenu?.top_menu;
	const getSettingsData = getData?.getSettings;
	const [isOpen, setIsOpen] = useState(false);
	const menuRef = useRef(null);
	const topSectionRef = useRef(null);
	const isMobile =
		typeof window !== 'undefined' ? window.innerWidth <= 1024 : false;
	const pathname = usePathname();
	const menuTimeline = useRef(null);
	const [activeMenuSlug, setActiveMenuSlug] = useState('#home');
	const router = useRouter();

	const ClickMenu = useCallback(() => {
		setIsOpen(true);
		ScrollTrigger.refresh()
	}, []);

	const CloseMenu = useCallback(() => {
		setIsOpen(false);
		ScrollTrigger.refresh()

	}, []);

	// Menu animation setup
	useEffect(() => {
		if (!menuRef.current || !topSectionRef.current) return;

		// Initial animation to make menu visible
		gsap.to('.site-menu', {
			opacity: 1,
			duration: 0.3,
			ease: 'power2.out'
		});

		if (!menuTimeline.current) {
			menuTimeline.current = gsap
				.timeline({ paused: true })
				.to(
					'.overlay',
					{
						display: 'block',
						duration: 0.3,
						opacity: 1,
						ease: 'power1.out',
					},
					0,
				)
				.to(
					menuRef.current,
					{
						visibility: 'visible',
						opacity: 1,
						x: '0',
						duration: 0.5,
						ease: 'power2.inOut',
					},
					'-=0.1',
				)
				.to(
					topSectionRef.current.querySelectorAll('.item-wrapper'),
					{
						opacity: 1,
						y: 0,
						duration: 0.3,
						stagger: 0.04,
						ease: 'power2.out',
					},
					'-=0.3',
				);
		}

		if (isOpen) {
			menuTimeline.current.play();
			document.body.classList.add('hidden');
		} else {
			menuTimeline.current.reverse();
			document.body.classList.remove('hidden');
		}

		return () => {
			document.body.classList.remove('hidden');
			if (menuTimeline.current) {
				menuTimeline.current.kill();
			}
		};

		/// Initialize GSAP animations
		const showAnim = gsap
			.from('.site-menu ', {
				yPercent: -100,
				paused: true,
				duration: 0.2,
				ease: 'Power3.easeOut',
			})
			.progress(1);

		// Main menu scroll trigger
		ScrollTrigger.create({
			scroller: getSettingsData.getScrollData,
			start: 'top top',
			end: 'bottom top', // More realistic end point
			onUpdate: self => {
				self.direction === -1 ? showAnim.play() : showAnim.reverse();
			},
		});
	}, [isOpen]);




	useEffect(() => {
		if (window.innerWidth <= 767) return;  // skip on mobile
		if (pathname !== '/' && !pathname.startsWith('/#')) return; // Only on homepage or hash

		const sections = getMenuData.map(item => {
			return document.getElementById(item.item_url.replace('#', ''));
		});

		function onScroll() {
			const scrollPos = window.scrollY + 100; // offset

			for (let i = sections.length - 1; i >= 0; i--) {
				const section = sections[i];

				if (section && section.offsetTop <= scrollPos) {
					setActiveMenuSlug(getMenuData[i].item_url);
					break;
				}
			}
		}

		window.addEventListener('scroll', onScroll);
		onScroll(); // initial check

		return () => window.removeEventListener('scroll', onScroll);
	}, [getMenuData, pathname]);




	const handleScrollTo = (e, hash) => {
		if (!hash) return;

		//Remove 'active' class from all menu items
		const menuItems = document.querySelectorAll('.middle_content .middle-menu li');
		menuItems.forEach(item => item.classList.remove('active'));

		// Add 'active' class to clicked menu item's parent <li>
		const activeItem = document.querySelector(`.middle_content .middle-menu li a[href="${hash}"]`);
		if (activeItem) {
			activeItem.parentElement.classList.add('active');
		}

		const id = hash.startsWith('#') ? hash.slice(1) : hash;
		const targetElement = document.getElementById(id);
		if (!targetElement) return;

		const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

		const offsets = {
			'#services': 0,
			'#products': 0,
		};

		const offset = offsets[hash] ?? 0;

		gsap.to(window, {
			scrollTo: targetPosition - offset,
			ease: "power2.out"
		});
		setActiveMenuSlug(hash);








	};





	return (
		<StyledComponent className={`site-menu `} offset={offset}>
			{/*middle menu 			*/}
			<div className="middle_content">
				<Container>
					<Row className={'menu-row'}>
						<Col md={3} className={'hamburger-btn'}>
							<Link href={'/'}  prefetch={true}>
								<img loading="lazy" src="/images/static/logo.svg" alt="logo" />
								<img loading="lazy"
									src="/images/static/logo-black.svg"
									alt="logo"
								/>
							</Link>
						</Col>
						{/*className={`${activeMenuSlug === item?.item_url ? 'active' : pathname === '/products' && item?.item_url === '#products' ? 'active' : pathname === '/news-and-events' && item?.item_url === '#news' ? 'active' : ''} `}*/}
						<Col md={9}>
							<ul className={'middle-menu'}>
								{getMenuData?.length > 0 &&
									getMenuData.map((item, index) => {
										return (
											<li
												key={`menu-${item.item_url}`}

												className={pathname === '/' &&
												activeMenuSlug === item.item_url ? 'active' : ''}
												>

												{
													pathname === '/' ?
														<Link
															data-scroll-to
															href={item?.item_url}
															className={`menu-item-${index}`}
															onClick={smoothScrollTo()}
														>
															{reactHtmlParser(
																item?.item_title,
															)}
														</Link>
														:
														<Link
															href={'/'+item?.item_url}

														>
															{reactHtmlParser(
																item?.item_title,
															)}
														</Link>

												}

											</li>
										);
									})}
							</ul>
						</Col>
						{isMobile && (
							<Col
								md={2}
								className={
									'button_wrapper d-flex align-items-center justify-content-end'
								}>
								<div onClick={ClickMenu} className="wrapper">
									<Hamburger open={isOpen} />
								</div>
							</Col>
						)}
					</Row>
				</Container>
			</div>
			<div className="overlay" onClick={CloseMenu}></div>

			{/*main menu hamburger*/}
			<div ref={menuRef} className="menu-overlay">
				<div ref={topSectionRef} className="top-section p-0 container">
					{getMenuDataHamburger &&
						getMenuDataHamburger?.length > 0 &&
						getMenuDataHamburger?.map((e, index) => {
							return (
								<div key={index} className="relative">
									<div className={'item-wrapper'}>
										<Link
											onClick={smoothScrollTo()}
											prefetch={true}
											href={e?.item_url}
											className={`nav-item nav-item-${0}`}>
											{ReactHtmlParser(e.item_title)}
										</Link>
									</div>
								</div>
							);
						})}
				</div>

				<div className=" p-0 mobile-menu container">
					<div onClick={CloseMenu} className="wrapper-close">
						<Hamburger close open={isOpen} />
					</div>
					{getMenuData &&
						getMenuData?.length > 0 &&
						getMenuData?.map((e, index) => {
							return (
								<div key={index} className="relative">
									<div className={'item-wrapper'}>
										<Link
											onClick={i => {
												const hash = e.item_url.split('#')[1];
												CloseMenu();

												if (hash) {
													// e.preventDefault();
													const el = document.getElementById(hash);
													if (el) {
														const newUrl = `${window.location.pathname}#${hash}`;
														window.history.replaceState(null, '', newUrl);
														handleScrollTo(e, `#${hash}`);
														ScrollTrigger.refresh();
													}
												}

											}}
											prefetch={true}
											href={pathname === '/' ? e?.item_url : '/' + e?.item_url}
											className={`nav-item nav-item-${0}`}>
											{ReactHtmlParser(e.item_title)}
										</Link>
									</div>
								</div>
							);
						})}
				</div>
			</div>
		</StyledComponent>
	);
};

export default React.memo(MenuComponent);
